<template>
    <div class="contacto">
            <div class="main col-lg-12">
                <h1 class="titulo_precio">Solicita tu demostración</h1>
                <div class="main-center">
                   <ValidationObserver ref="form">
                        <b-form id="form" class="form-container" @submit.prevent="onSubmit">
                        <div class="form-group">
                            <label for="nombre">Nombre completo*</label>
                            <ValidationProvider rules="required|alpha_spaces|max:80"  v-slot="{ errors }">
                                <b-form-input v-model="form.nombre" name="nombre" type="text" />
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label for="email">Correo empresarial*</label>
                            <ValidationProvider rules="required|email|max:80" v-slot="{ errors }">
                                <b-form-input v-model="form.email" name="email" type="email" />
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label for="empresa">Nombre de la empresa</label>
                            <ValidationProvider rules="max:100" v-slot="{ errors }">
                                <b-form-input v-model="form.empresa" name="empresa" type="text" />
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label for="tel">Número de teléfono*</label>
                            <ValidationProvider rules="required|numeric|min:6|max:20" v-slot="{ errors }">
                                <b-form-input v-model="form.telefono" name="telefono" type="text" />
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div class="form-group">
                            <label for="message">Mensaje</label>
                            <ValidationProvider rules="max:300" v-slot="{ errors }">
                                <b-form-textarea v-model="form.mensaje" name="mensaje" rows="6"  />
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <b-form-group class="text-left">
                            <b-form-checkbox type="checkbox" class="priv" v-model="form.checked">
                                He leído y acepto el <b-link class="cliker-text" href="#" to="/aviso">Aviso de Privacidad</b-link> *
                            </b-form-checkbox>
                        </b-form-group>
                        <b-button pill v-show="!loading" type="submit"  class="btnSend">ENVIAR</b-button>
                        <b-button pill v-show="loading" class="btnSend disabled"><b-spinner small class="mr-2"></b-spinner>ENVIANDO</b-button>
                    </b-form>
                    </ValidationObserver>
                    <p class="help">¿Tienes dudas? Comunícate con <br>nosotros al <a class="cliker-text" :href="'tel:'+tel1">{{tel1}}</a></p>
                    <p class="google-terms">Este sitio está protegido por reCAPTCHA y Google, las
                      <a href = "https://policies.google.com/privacy"> Política de privacidad </a> y las
                      <a href = "https://policies.google.com/terms"> Condiciones del servicio </A> aplican.</p>
                </div><!--main-center"-->
            </div><!--main-->
    </div>
</template>

<script>

import contactoApi from "../api/contacto";
import {ValidationProvider,ValidationObserver} from 'vee-validate';
import {mapState,mapActions} from "vuex";
import Notify from "@/plugins/notify";
import Swal from "sweetalert2";


export default {
  name: 'contacto',
  components: {
      ValidationProvider,
      ValidationObserver
  },
  data() {
      return {
        form :{
            nombre      : '',
            email      : '',
            empresa     : '',
            telefono    : '',
            mensaje  : '',
            checked     : false
        },
        show            : true,
        loading:false
      }
    },
    computed: {
        ...mapState("contact",["tel1"]),
        ...mapState("menu",["principal"])
    },
    methods: {
      ...mapActions("menu",["setMenu"]),
      onSubmit(){
  
        this.$recaptcha("login").then(token => {this.sendContact();});

      },
  
    async sendContact(){
      var isValid = await this.$refs.form.validate();
      if (!isValid) {
        
      }else if(this.form.checked){
        this.loading = true;
        let parametros = this.form;
        await contactoApi
          .postContacto(parametros)
          .then(response => {
            Notify.Success("¡Excelente!", "Apenas recibamos tus datos nos comunicaremos contigo para brindarte toda la atención.");
            this.reset();
          }).catch(err => {
            Notify.Error("No eres tu, somos nostros.", "","Lo sentimos, en este momento no fue posible enviar tu contacto, inténtalo nuevamente o comunícate con nosotros al <a href='tel:"+this.tel1+"'>"+this.tel1+"</a>");
          });
      }else{
        Notify.ErrorToast("Acepta nuestro Aviso de Privacidad para continuar con el envió del formulario.");
      }
      this.loading = false;
    },
    reset() {

      this.form ={ 
            nombre      : '',
            email      : '',
            empresa     : '',
            telefono    : '',
            mensaje  : '',
            checked     : false
        };

      this.$nextTick(() => {
          this.$refs.form.reset();
        });
      },
    isMobile(){
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    },
    init(){
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera;

      this.setMenu(true);
    }
    },
    created () {
      this.init();
    },
}
</script>

<style scoped>
.titulo_precio {
        font-family: Muli-Extrabold;
        font-style: normal;
        font-size: 38px;
        line-height: 38px;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        padding-bottom: 60px;
        padding-top: 80px;
        color: #1E2144;
    }

.google-terms{
     margin:15px;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #828282;
}

.error{
    font-family: Muli;
    font-style: normal;
    font-size: 12px;
    color:red;
}
    h5 {
        font-family: Muli;
        font-style: normal;
        font-size: 38px;
        line-height: 18px;

        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: #1E2144;

        margin: 100px 0px;
    }
    .btnDemo {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    margin-top: 30px;
    padding: 13px 27px;
  }

  .btnDemo:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .btnSend {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    margin-top: 30px;
    padding: 13px 27px;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .cliker-text{
      color:#2DB9D1;
  }

    
    .main input {
        font-size: 11px;
        padding-top: 3px;
        border: 1px solid #E0E0E0;
        border-radius: 5px;
    }
    .main-center{
        margin-top: 30px;
        margin-bottom: 120px !important;
        margin: 0 auto;
        max-width: 500px;
        padding: 10px 60px;
        background:#FFFFFF;
        text-shadow: none;
        -webkit-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        -moz-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        border-radius: 25px;
    }

   .form-container {
        padding: 50px 0px;
    }
  .form-group{
    margin-bottom: 30px;
  }
    .form-group > label {
        font-family: Muli-Light;
        font-style: normal;
        font-size: 14px;
        line-height: 10px;
        float:left;
        margin-left:20px;
        letter-spacing: 2px;
        color: #1E2144;
    }

    
    .placeholder {
        font-family: Muli-Light;
        font-style: normal;
        font-size: 14px;
        line-height: 30px;

        display: flex;
        align-items: center;

        color: #BDBDBD;
    }

    .help {
      margin-top: 50px;
      font-family: Muli;
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 20px;
      align-items: center;
      text-align: center;
      letter-spacing: 1px;
      color: #1E2144;
    }
    .priv {
      font-family: Muli;
      font-style: normal;
      font-weight: 300;
      font-size: 13px;
      line-height: 30px;
      letter-spacing: 1px;
      color: #1E2144;
    }

    span.input-group-addon i {
        color: #009edf;
        font-size: 17px;
    }

     @media(max-width: 768px){
          h5 {
        font-size: 24px;
        line-height: 35px;
        margin: 0px 0px;
    }

        .main-center{
        padding:0px;
        background: none;
        -webkit-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        -moz-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        }

.btnSend {
    width: 100%;
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    margin-top: 30px;
    padding: 13px 27px;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }
        
     }
</style>